export default __webpack_public_path__ + "static/media/03.ba5f8794.jpg";